import Bugsnag from '@bugsnag/js'

export const addLogMetadata = Bugsnag.addMetadata
